import React from 'react';
import { X, Check } from 'lucide-react';

const them = [
  'Sell you "leads"',
  'Show you dashboards',
  'Use junior staff',
  'Lock you into contracts',
  'Talk about "funnels"',
];

const us = [
  'Get you customers',
  'Show you revenue',
  'Senior team only',
  'Skin in the game',
  'Talk about money',
];

const WhyWereDifferent = () => {
  return (
    <section data-testid="why-different-section" className="section" style={{ backgroundColor: 'var(--bg-primary)' }}>
      <div className="container">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="heading-lg mb-4">How We're Different</h2>
            <p className="text-base md:text-lg" style={{ color: 'var(--text-secondary)', maxWidth: '600px', margin: '0 auto' }}>
              Most agencies sell you a dashboard and call it a day. We think that's garbage.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
            {/* Them */}
            <div className="p-8 rounded-2xl border border-gray-200 bg-gray-50">
              <h3 className="text-lg font-bold mb-6 text-gray-400 uppercase tracking-wider">Typical Agency</h3>
              <ul className="space-y-4">
                {them.map((item) => (
                  <li key={item} className="flex items-center gap-3">
                    <X className="w-5 h-5 flex-shrink-0 text-red-400" />
                    <span style={{ color: 'var(--text-secondary)' }}>{item}</span>
                  </li>
                ))}
              </ul>
            </div>

            {/* Us */}
            <div
              className="p-8 rounded-2xl border-2"
              style={{ borderColor: 'var(--brand-primary)', backgroundColor: 'var(--bg-accent)' }}
            >
              <h3 className="text-lg font-bold mb-6 uppercase tracking-wider" style={{ color: 'var(--brand-primary)' }}>
                B2B Rev Co
              </h3>
              <ul className="space-y-4">
                {us.map((item) => (
                  <li key={item} className="flex items-center gap-3">
                    <Check className="w-5 h-5 flex-shrink-0" style={{ color: 'var(--brand-success)' }} />
                    <span className="font-medium" style={{ color: 'var(--text-primary)' }}>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="text-center p-10 rounded-2xl" style={{ backgroundColor: 'var(--bg-secondary)' }}>
            <p className="text-xl font-bold mb-3" style={{ color: 'var(--text-primary)' }}>
              If you want pretty reports and marketing jargon, hire an agency.
            </p>
            <p className="text-base md:text-lg" style={{ color: 'var(--brand-primary)' }}>
              If you want customers and revenue, call us.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyWereDifferent;
